import { get, post, put, urlApiTegra } from "../../../service/api";

export const getRoleInProject = ({ token }) => {
  return get(`${urlApiTegra}/roles`, token);
};

export const postRoleInProject = ({ body, token }) => {
  return post(`${urlApiTegra}/roles`, body, token);
};

export const putRoleInProject = ({ body, id, token }) => {
  return put(`${urlApiTegra}/roles/${id}`, body, token);
};
